<template>
  <div class="student-dashboard">
    <!-- 顶部统计卡片 -->
    <div class="stats-cards">
      <div class="stat-card study-progress-card">
        <div class="stat-header">
          <div class="stat-icon study-icon">
            <i class="fa fa-calendar-check"></i>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ progressPercentage }}%</div>
            <div class="stat-label">学习进度</div>
          </div>
        </div>
        <div class="progress-section">
          <div class="progress-bar">
            <div class="progress-fill" :style="{ width: progressPercentage + '%' }"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主要功能区域 -->
    <div class="main-content">
      <div class="recent-errors">
        <div class="section-header">
          <h3>最近错题</h3>
          <router-link to="/student/error-book" class="view-all">查看全部</router-link>
        </div>
        <div class="error-list">
          <div
            v-for="error in recentErrors"
            :key="error.id"
            class="error-item"
            @click="viewErrorDetail(error)"
          >
            <div class="error-image">
              <img :src="error.imageUrl" :alt="error.subject" />
            </div>
            <div class="error-content">
              <div class="error-subject">{{ error.subject }}</div>
              <div class="error-knowledge">{{ error.knowledgePoint }}</div>
              <div class="error-time">{{ formatTime(error.createTime) }}</div>
            </div>
            <div class="error-status" :class="error.status">
              {{ error.status === 'mastered' ? '已掌握' : '未掌握' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axios } from "../../config/axios";
import moment from 'moment';

export default {
  name: 'StudentDashboard',
  data() {
    return {
      progressPercentage: 0,
      recentErrors: []
    }
  },
  created() {
    this.loadDashboardData();
  },
  methods: {
    async loadDashboardData() {
      try {
        await this.loadProgress();
        await this.loadRecentErrors();
      } catch (error) {
        console.error('加载仪表板数据失败:', error);
        this.$message.error('加载数据失败，请刷新重试');
      }
    },
    
    async loadProgress() {
      try {
        const response = await axios.get('/student/progress');
        const data = response.data.data;
        this.progressPercentage = data.progressPercentage || 0;
      } catch (error) {
        console.error('加载进度数据失败:', error);
        this.progressPercentage = 65;
      }
    },
    
    async loadRecentErrors() {
      try {
        const response = await axios.get('/requestErrorRecord/recent-list');
        const res = response.data;
        if (res.code !== 200) {
          this.recentErrors = [];
          this.$message.error(res.message || '加载最近错题失败');
          return;
        }
        this.recentErrors = (res.data || []).filter(item => item && item.id).map(item => ({
          ...item,
          status: item.mastered ? 'mastered' : 'unmastered',
          subject: item.subject || '未知',
          knowledgePoint: item.knowledgePoint || '未知',
          imageUrl: item.paperCutImg || item.dealImgUrl || '',
          createTime: item.createTime || new Date()
        }));
      } catch (error) {
        console.error('加载最近错题失败:', error);
        this.recentErrors = [];
        this.$message.error('加载最近错题失败');
      }
    },
    
    viewErrorDetail(error) {
      this.$router.push(`/student/practice/${error.id}`);
    },
    
    formatTime(time) {
      return moment(time).format('MM-DD HH:mm');
    }
  }
}
</script>

<style lang="less" scoped>
.student-dashboard {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100%;
}

// 统计卡片
.stats-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  }
}

.study-progress-card {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.stat-header {
  display: flex;
  align-items: center;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
  
  i {
    font-size: 24px;
    color: white;
  }
  
  &.study-icon {
    background: linear-gradient(135deg, #f093fb, #f5576c);
  }
}

.stat-content {
  flex: 1;
}

.stat-number {
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 14px;
  color: #7f8c8d;
}

// 主要内容区域
.main-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
}

.recent-errors {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.progress-section {
  width: 100%;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  
  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
  }
}

.view-all {
  color: #3498db;
  text-decoration: none;
  font-size: 14px;
  
  &:hover {
    color: #2980b9;
  }
}

.progress-bar {
  height: 8px;
  background-color: #ecf0f1;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #27ae60, #2ecc71);
  border-radius: 4px;
  transition: width 0.3s ease;
}

// 最近错题
.error-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.error-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #e9ecef;
  }
}

.error-image {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  overflow: hidden;
  margin-right: 12px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.error-content {
  flex: 1;
}

.error-subject {
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 4px;
}

.error-knowledge {
  font-size: 12px;
  color: #7f8c8d;
  margin-bottom: 2px;
}

.error-time {
  font-size: 11px;
  color: #95a5a6;
}

.error-status {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  
  &.mastered {
    background-color: #d4edda;
    color: #155724;
  }
  
  &.unmastered {
    background-color: #f8d7da;
    color: #721c24;
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .main-content {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .student-dashboard {
    padding: 15px;
  }
  
  .stats-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  
  .stat-card {
    padding: 16px;
  }
  
  .stat-icon {
    width: 48px;
    height: 48px;
    margin-right: 12px;
    
    i {
      font-size: 20px;
    }
  }
  
  .stat-number {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .stats-cards {
    grid-template-columns: 1fr;
  }
}
</style>
